import { Trans } from "react-i18next";
import { useParams } from "react-router-dom";
import { useSiteConfig } from "../config/SiteConfigContext";
import { pathFor } from "../app/paths";

/**
 * Informativa privacy GDPR nei form: finalità A) per i contatti, B), C) e D) per
 * la registrazione (la stessa frase compare anche sotto il login).
 *
 * Il testo legale sta nell'i18n (chiavi `contact.consent` / `auth.consent`); la sola
 * parola "informativa" / "information" / "Informationen" è marcata
 * `<privacyLink>…</privacyLink>` nella stringa di traduzione e resa qui come <a> REALE
 * via <Trans> — nessun dangerouslySetInnerHTML. Il link apre la pagina Privacy Policy
 * interna del progetto (/{locale}/privacy) nella lingua corrente, in una nuova scheda.
 *
 * Il marcatore NON può chiamarsi `<link>`: per il parser di <Trans> è l'elemento HTML
 * vuoto (come <br>), e la parola finiva fuori da un'ancora vuota — il link c'era ma non
 * si poteva cliccare. Stessa trappola con area, base, br, col, embed, hr, img, input,
 * meta, source, track, wbr.
 */
export function PrivacyNotice({
  variant,
  style,
}: {
  variant: "contact" | "auth";
  style?: React.CSSProperties;
}) {
  const { locale } = useParams();
  const cfg = useSiteConfig();
  const privacyUrl = pathFor("privacy", locale);
  return (
    <p style={{ fontSize: 12, color: "rgba(28,75,59,0.65)", lineHeight: 1.6, margin: 0, ...style }}>
      <Trans
        i18nKey={variant === "contact" ? "contact.consent" : "auth.consent"}
        components={{
          privacyLink: (
            <a
              href={privacyUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: cfg.color_dark, textDecoration: "underline", fontWeight: 600 }}
            />
          ),
        }}
      />
    </p>
  );
}
